import React from 'react';
import './NossosProfissionais.css';
import Marisa from '../../assets/profissionais/prof3.png'
import Luisa from '../../assets/profissionais/prof2.png'
import Thaisa from '../../assets/profissionais/prof1.png'
import Marli from '../../assets/profissionais/prof4.png'
import '../../../src/styles/mediaqueries.css';

function NossosProfissionais() {
  const profissionais = [
    {
      nome: 'Thaísa Viana',
      cargo: 'Terapeuta Ocupacional',
      descricao: '"Sou apaixonada pelo meu trabalho, me encontrei no que eu faço, principalmente no trabalho com as crianças." ',
      imagem: Thaisa,
      link: '/profissionais/thaisaviana'
    },
    {
      nome: 'Luísa Viana',
      cargo: 'Arteterapeuta',
      descricao: '"Meu foco se tornou trabalhar a arte como cura, como um poderoso instrumento do autoconhecimento."',
      imagem: Luisa,
      link: '/profissionais/luisaviana'
    },
    {
      nome: 'Marli Miranda',
      cargo: 'Orientação Familiar',
      descricao: '"Sabemos que cada criança é única, e as abordagens que funcionam para uma podem não ser eficazes para outra."',
      imagem: Marli,
      link: '/profissionais/marlimiranda'
    },
    {
      nome: 'Marisa Mathes',
      cargo: 'Orientadora Educacional',
      descricao: '"É com grande dedicação que exerço minha função, voltada para o apoio à famílias, crianças e educadores."',
      imagem: Marisa,
      link: '/profissionais/marisamathes'
    },
  ];
  
  const abrirPagina = (link) => {
    window.open(link, '_blank'); // Abre em uma nova guia
  };

  return (
    <section className="section-white">
      <div className="container">
        <div className="text-center">
          <h2 className="section-title">Nossos Profissionais</h2>
          <p className="section-subtitle">Clique para saber mais sobre os profissionais e suas abordagens!</p>
        </div>
        <div className="team-container">
          {profissionais.map((profissional, index) => (
            <div className="team-item" key={index} onClick={() => abrirPagina(profissional.link)}>
              <img src={profissional.imagem} alt={profissional.nome} className="team-img" />
              <h3>{profissional.nome}</h3>
              <div className="team-info">
                <p>{profissional.cargo}</p>
              </div>
              <div className="team-desc">
                <p>{profissional.descricao}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default NossosProfissionais;
